import { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { Splash, shouldShowSplash } from "./Splash";
import { SoundToggle } from "./SoundToggle";

export default function SiteLayout() {
  const { pathname } = useLocation();
  const [splash] = useState(shouldShowSplash);
  const [ready, setReady] = useState(!splash);
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return (
    <div className="glow-bg grain relative min-h-screen">
      {splash && <Splash onReady={() => setReady(true)} />}
      <SoundToggle />
      {ready && (
        <>
          <Header />
          <main className="relative">
            <Outlet />
          </main>
          <Footer />
        </>
      )}
    </div>
  );
}
